// https://conf.cian.tech/pages/viewpage.action?pageId=16154881

import {Region, GeoItem} from '../../../../serp/classes';

angular.module('cian.geoInput')
.controller('GeoInputCtrl', ["$scope", '$window', "$log", "GeoSuggest", "GeoSearch", "FilterService", "HighwaysService", "RegionUtilsService", "AnalyticsService", function($scope, $window, $log, GeoSuggest, GeoSearch, FilterService, HighwaysService, RegionUtilsService, AnalyticsService) {
  const ctrl = {};

  function newBuildingsAvailableForSearch() {
    return FilterService.categoryIs('flat') &&
      RegionUtilsService.areNewBuildingsAvailable(FilterService.selectedRegions);
  }

  ctrl.getSuggest = val => (val && val.trim()) && GeoSuggest.suggest(
    val,
    FilterService.selectedRegions,
    {
      suggestNewBuildings: newBuildingsAvailableForSearch(),
      suggestHighways: FilterService.isHighwayAvailable(),
      suggestBC: FilterService.categoryIs('commercial'),
    }
  );

  function resetInputState() {
    ctrl.addressInput = '';
    focus('.search-address__input');
  }

  ctrl.select = $item => {
    // Если это шоссе, то сразу добавляем
    if ($item.type === 'highway' || $item.type === 'bs_center') {
      resetInputState();
      FilterService.add($item);
      return;
    }

    ctrl.isLoading = true;

    GeoSearch
      .checkAddress($item)
      .then(geoItem => {
        resetInputState();

        if (geoItem instanceof Region) {
          AnalyticsService.trackCA('Listing', 'GEO_string_change', geoItem.parentId ? 'city' : 'region', {});

          // Выбран регион - меняем
          FilterService.setRegions([geoItem]);
        } else if (geoItem instanceof GeoItem) {
          AnalyticsService.trackCA('Listing', 'GEO_string_change', geoItem.type, {});

          // Выбран гео-объект
          FilterService.addRegion(geoItem.parentRegion);
          if (FilterService.isHighwayAvailable() && HighwaysService.streetIsHighway(geoItem)) {
            HighwaysService
              .getHighwayFromStreet(geoItem, [geoItem.parentRegion])
              .then(FilterService.add)
              // Если не нашли подходящее шоссе, то добавляем как улицу
              .catch(() => FilterService.add(geoItem));
          } else {
            FilterService.add(geoItem);
          }
        }
      })
      .catch((error) => {
        $log.error(error);
        Notifications.add({
          type: 'error',
          content: error,
          timeout: 3000
        });
      })
      .finally(() => ctrl.isLoading = false);
  };

  ctrl.getPlaceholder = () =>
    newBuildingsAvailableForSearch() ?
    'Город, адрес, метро, район, шоссе или ЖК' :
    'Город, адрес, метро, район или шоссе';

  ctrl.isNew = newBuildingsAvailableForSearch;
  ctrl.trackingJkLinkClick = function(event) {
    event.stopPropagation();

    window.ca && ca('event', {
      name: 'oldevent',
      category: 'Listing',
      action: 'click_suggest',
      label: 'jk'
    });
  };

  return ctrl;
}]);



// WEBPACK FOOTER //
// ./src/components/geo-input/src/scripts/cian.geo-input.ctrl.js